import styled, { css } from 'styled-components'

export const StyledTabs = styled.div`
  align-items: center;
  display: flex;
`

const activeTab = css`
  color: #333333;
  font-weight: 700;
  line-height: 20px;

  a {
    color: #333333 !important;
  }

  &::after {
    background: #6a58dc;
  }
`

export const StyledTab = styled.div<{ active?: boolean }>`
  color: #6f7390;
  cursor: pointer;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  position: relative;

  a {
    color: #6f7390 !important;
  }

  &::after {
    content: '';
    background: transparent;
    border-radius: 19px;
    bottom: -5px;
    display: block;
    height: 2px;
    left: calc(50% - 10px);
    position: absolute;
    width: 20px;
  }

  ${({ active }) => (active ? activeTab : null)}
`

export const StyledPipe = styled.div`
  background: #ebebeb;
  height: 12px;
  margin: 0 20px;
  opacity: 0.7;
  width: 1px;
`
